import Eevee from './Eevee';

export default Eevee;



/** WEBPACK FOOTER **
 ** ./source/133-eevee/index.js
 **/